import { Table } from 'reactstrap';

export const EquipmentOnSite = ({ resources }) => (
    <Table
        className="table table-sm"
        bordered
        responsive
    >
        <thead>
            <tr>
                <th>
                    Resource
                </th>

                <th>
                    # On Site
                </th>
            </tr>
        </thead>

        <tbody>
            {(resources || []).map((resource) => (
                <tr key={resource.id}>
                    <td>
                        {resource.equipmentTypeName}
                    </td>

                    <td>
                        {resource.actualQuantity}
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
);